<template>
    <transition name="fade">
        <div v-if="show" class="still-watching-prompt">
            <div class="prompt-content">
                <h2>Are you still watching?</h2>
                <button @click="yes">Yes</button>
                <button class="secondary" @click="no">No</button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'aystw',
  props: {
    yes: Function,
    no: Function,
    show: Boolean,
  },

  computed: { },

  data: function(){
    return { }
  },

  methods: { },

  mounted: function(){ }
}
</script>

<style scoped lang="scss">
.still-watching-prompt {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;

    .prompt-content {
        text-align: center;
        color: white;

        h2 {
            font-size: 2em;
            margin-bottom: 20px;
        }

        button {
            padding: 10px 30px;
            font-size: 1.2em;
            background-color: #e50914;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            &.secondary{
                background-color: white;
                color: black;
                margin-left: 22px;

            }
        }

    }
}

</style>
